module.exports = __webpack_public_path__ + "static/media/loading.3320bc70.gif";